import { render } from "./StatsEditor.vue?vue&type=template&id=0173905c"
import script from "./StatsEditor.vue?vue&type=script&lang=ts"
export * from "./StatsEditor.vue?vue&type=script&lang=ts"

import "./StatsEditor.vue?vue&type=style&index=0&id=0173905c&lang=scss"
script.render = render

export default script